import axios from 'axios';
import {
  SET_CONTEXT_SUCCESS,
  FETCH_CONTEXTS_SUCCESS,
  FETCHING_CONTEXTS,
  FETCHING_USER,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAIL
} from './ContextsConstants';
import authenticationHelper from 'shared/helpers/authenticationHelper';
import { fetchUserPermissions } from 'redux/manageUser/ManageUserActions';

const iamUsersPath = '/v1/iam/users';

const fetchContextsSuccess = (contexts, selectedOrgId) => ({ type: FETCH_CONTEXTS_SUCCESS, contexts, selectedOrgId });
const fetchingContexts = () => ({ type: FETCHING_CONTEXTS });
const fetchingUser = () => ({ type: FETCHING_USER });
const fetchUserSuccess = userInfo => ({ type: FETCH_USER_SUCCESS, userInfo });
const fetchUserFailed = () => ({ type: FETCH_USER_FAIL });

const setContext = newOrg => dispatch =>{
  dispatch({ type: SET_CONTEXT_SUCCESS, newOrg });
  dispatch(fetchUserPermissions());
};

const fetchContexts = selectedOrgId => async dispatch => {
  dispatch(fetchingContexts());
  axios
    .get(`${iamUsersPath}/clients/orgs`)
    .then(response => {
      const allOrgs = response.data.data;
      dispatch(fetchContextsSuccess(allOrgs, selectedOrgId));
    })
    .catch(error => {
      throw error;
    });
};

const fetchUser = () => async dispatch => {
  dispatch(fetchingUser());
  const userId = authenticationHelper.getDecodedToken().sub;
  axios
    .get(`${iamUsersPath}/${userId}`)
    .then(response => {
      dispatch(fetchUserSuccess(response.data.data));
    })
    .catch(dispatch(fetchUserFailed()));
};

export { fetchContexts, fetchUser, setContext };



// WEBPACK FOOTER //
// ./src/redux/contexts/ContextsActions.js